module.exports = __webpack_public_path__ + "static/media/nulltx.f89372aa.png";